// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Wur_","controls":"styles_controls__3nhdP","charLimit":"styles_charLimit__2VgL2","input":"styles_input__1uGik","send":"styles_send__3zqme"};